import * as React from "react";

function Filter(props) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.584 5.417c-1.088 0-2.001-.744-2.26-1.75H.167V2.5h4.157a2.334 2.334 0 112.26 2.917zm3.5-2.917h1.75v1.167h-1.75V2.5zm-6.417 8.75c-1.087 0-2-.744-2.26-1.75H.167V8.333h1.24a2.334 2.334 0 112.26 2.917zm3.5-1.75h4.667V8.333H7.167V9.5zm-2.333-.583a1.167 1.167 0 11-2.334 0 1.167 1.167 0 012.334 0zM7.75 3.083a1.167 1.167 0 11-2.333 0 1.167 1.167 0 012.333 0z"
      />
    </svg>
  );
}

export default Filter;
